import React, { useRef } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { type SnackbarAction, SnackbarProvider as _SnackbarProvider } from 'notistack';

export const SnackbarProvider = ({ children }) => {
    const snackbarRef = useRef<_SnackbarProvider>(null);

    const snackbarAction: SnackbarAction = (key) => (
        <IconButton
            color="inherit"
            onClick={() => snackbarRef.current?.closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    )

    return <_SnackbarProvider
        className="snackbar_div"
        maxSnack={3}
        ref={snackbarRef}
        action={snackbarAction}
        children={children}
    />
}